import { API_V4_ENTITIES } from 'constants/entities';
import CoreService from './CoreService';

class EntityService extends CoreService {
  constructor(endpoint) {
    super(endpoint);
  }

  fetch(entity, uid, params = {}) {
    let path = `/${entity}`;
    if (API_V4_ENTITIES.includes(entity)) {
      path = `${this.baseUrl}/v4${path}`;
    }
    return this.api.get(path, {
      params,
    });
  }

  generateLocationLinks(vanity) {
    return this.api.post(`/location/${vanity}/generatelink`);
  }

  generateLookQrCode(shortId) {
    const path = `${this.baseUrl}/v2/store/${shortId}/generatelink`;

    return this.api.post(path);
  }

  getBundleTimeZones(uid) {
    const path = `${this.baseUrl}/v2/store/${uid}/available_timezones`;

    return this.api.get(path);
  }

  getBrandContentTimeZones() {
    return this.api.get('/brand_content/available_timezones');
  }
}

const instance = new EntityService('/v3');

export default instance;
